import { LargeListSkeleton } from '@Components/General/Skeletons'
import { createFileRoute } from '@tanstack/react-router'
import { emailsSentQueryOptions } from '@utils/queryOptions'
import EmailsSent from '@Views/Emails/sent'

export const Route = createFileRoute('/emails/(sent)/')({
  component: EmailsSent,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(emailsSentQueryOptions(opts.deps)),
  loaderDeps: ({ search }) => search,
  pendingComponent: LargeListSkeleton,
})
